import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import { useContext, useEffect, useRef } from "react";
import { GeneralContext } from "../../hooks/GeneralContext";
import gsap from "gsap";

export default function Navbar() {
  const { navOpen, setNavOpen } = useContext(GeneralContext);
  const navRef = useRef(null);
  const logoRef = useRef(null);
  const linksRef = useRef(null);
  const burgerRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname, setNavOpen]);

  // entrance
  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(logoRef.current, { y: -30, opacity: 0, duration: 0.8, ease: "power3.out", delay: 0.1 });
      gsap.from(".nav-link", { y: -20, opacity: 0, stagger: 0.08, duration: 0.6, ease: "power3.out", delay: 0.35 });
      gsap.from(burgerRef.current, { opacity: 0, duration: 0.5, delay: 0.4 });
    }, navRef);
    return () => ctx.revert();
  }, []);

  // scroll glass
  useEffect(() => {
    const el = navRef.current;
    if (!el) return;
    const onScroll = () => {
      if (window.scrollY > 16) el.classList.add("scrolled");
      else el.classList.remove("scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // mobile menu gsap
  useEffect(() => {
    const links = linksRef.current;
    if (!links) return;
    if (window.innerWidth > 750) return;
    if (navOpen) {
      gsap.to(links, { x: 0, duration: 0.55, ease: "power3.out", overwrite: true });
      gsap.fromTo(".nav-link", { y: 30, opacity: 0 }, { y: 0, opacity: 1, stagger: 0.07, duration: 0.5, ease: "power3.out", delay: 0.15, overwrite: true });
    } else {
      gsap.to(links, { x: "-110%", duration: 0.45, ease: "power3.inOut", overwrite: true });
    }
  }, [navOpen]);

  return (
    <nav ref={navRef} className="navbar">
      <div className="navbar-inner">
        <NavLink to="/" className="logo" ref={logoRef}>
          <span className="logo-mark">Y</span> Yishak<span className="logo-dot">.</span>
        </NavLink>

        <div ref={linksRef} className={navOpen ? "nav-links open" : "nav-links"}>
          <NavLink onClick={() => setNavOpen(false)} to="/" className="nav-link">
            <span>Home</span>
          </NavLink>
          <NavLink onClick={() => setNavOpen(false)} to="/projects" className="nav-link">
            <span>Projects</span>
          </NavLink>
          <NavLink onClick={() => setNavOpen(false)} to="/contact" className="nav-link">
            <span>Contact</span>
          </NavLink>
          <a href="mailto:yishak.110402@gmail.com" className="nav-cta nav-link">
            Let's talk →
          </a>
        </div>

        <button
          ref={burgerRef}
          aria-label="Toggle menu"
          aria-expanded={navOpen}
          onClick={() => setNavOpen(!navOpen)}
          className={`hamburger ${navOpen ? "open" : ""}`}>
          <span />
          <span />
          <span />
        </button>
      </div>
    </nav>
  );
}
